module.exports = __webpack_public_path__ + "static/btn_014.8e344bcf.png";